import { Divider, Tab, Theme } from '@mui/material';
import { Nullable } from 'common-types';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import InfoIcon from '../../../elements/InfoIcon/InfoIcon';
import useOxNamedTabs from '../../../elements/OxTabs/hooks/useOxNamedTabs';
import OxTabs from '../../../elements/OxTabs/OxTabs';
import { ArtifactInfo } from '../../types/artifacts-type';
import { tabs } from './artifact-tabs';

const ArtifactCard: FC<React.PropsWithChildren<ArtifactCardProps>> = ({
  artifact,
}) => {
  const { classes, cx } = useStyles();
  const { selectedKey, handleTabChange } = useOxNamedTabs('Overview');
  const tab =
    tabs.find(t => t.name === selectedKey) ||
    tabs.find(t => t.name === 'Overview');

  if (!artifact || !tab) {
    return null;
  }

  const { Component } = tab;

  return (
    <>
      <OxTabs
        selectedTab={selectedKey}
        onChange={handleTabChange}
        className={classes.stickyTabs}>
        {tabs
          .filter(tab => tab.shouldShow(artifact))
          .map(({ name, infoIconTooltip }) => (
            <Tab
              value={name}
              key={name}
              label={name}
              icon={
                <>
                  {infoIconTooltip && (
                    <InfoIcon title={infoIconTooltip} marginX={1} />
                  )}
                </>
              }
              iconPosition='end'
              classes={{
                root: cx(name === 'Overview' && classes.firstTab),
              }}
              sx={{
                fontSize: 12,
                minHeight: '4em',
              }}
            />
          ))}
      </OxTabs>
      <Divider />
      <div className={classes.content}>
        <Component artifact={artifact} classes={classes} />
      </div>
    </>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  artifactCard: {
    padding: theme.spacing(2),
  },
  header: {
    paddingBlockStart: theme.spacing(3),
  },
  rowTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  supplyChainSection: {
    marginBlockStart: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(2),
  },
  stickyTabs: {
    position: 'sticky',
    top: 0,
    background: theme.palette.background.paper,
    zIndex: theme.zIndex.appBar,
  },
  firstTab: {
    paddingInlineStart: theme.spacing(3),
  },
}));

export interface ArtifactCardProps {
  artifact: Nullable<ArtifactInfo>;
}

export default ArtifactCard;
